import {
  Card,
  CardBody,
  HStack,
  Heading,
  Button,
  Image,
  Text,
  Badge,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Flex,
} from '@chakra-ui/react';

const TryAppCard = ({
  icon,
  name,
  description,
  onClick,
  isLoading,
  isPendingActivation,
}: {
  icon: string;
  name: string;
  description: string;
  onClick: () => void;
  isLoading: boolean;
  isPendingActivation: boolean;
}) =>
  isLoading ? (
    <TryAppCardSkeleton />
  ) : (
    <Card
      variant='flat'
      size='md'
      data-testid={`discover-apps-${name}`}
      width='340px'
      height='200px'
    >
      <CardBody
        display='flex'
        flexDirection='column'
        justifyContent='space-between'
        height='100%'
      >
        <>
          <HStack spacing='3' alignItems='center'>
            <Image width='10' height='10' src={icon} alt='app icon' />
            <Heading size='sm'>{name}</Heading>
            <Badge>FREE</Badge>
          </HStack>
          <Text mt='4' mb='6' variant='subtle' noOfLines={3}>
            {description}
          </Text>
        </>
        <Flex>
          <Button
            data-testid={`try-app-${name}-enable`}
            variant='outline'
            onClick={onClick}
            aria-label={`enable ${name}`}
            isDisabled={isPendingActivation}
          >
            {isPendingActivation ? 'Request submitted' : 'Enable'}
          </Button>
        </Flex>
      </CardBody>
    </Card>
  );

const TryAppCardSkeleton = () => (
  <Card variant='flat' size='md' minW='sm'>
    <CardBody>
      <HStack spacing='6' alignItems='center'>
        <SkeletonCircle size='10' />
        <Skeleton height='30px' width='80px' />
        <Skeleton height='25px' width='50px' />
      </HStack>
      <SkeletonText mt='4' mb='8' noOfLines={2} spacing='4' />
      <Skeleton height='40px' width='20%' rounded={50} />
    </CardBody>
  </Card>
);

export default TryAppCard;
